import { Component, OnInit } from '@angular/core';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-factorings',
  templateUrl: './factorings.component.html',
  styleUrls: ['./factorings.component.css']
})
export class FactoringsComponent implements OnInit {
    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_factorings_grid')
                .setLoadDataFunction({
                    method: 3463,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' });
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('factorings', {
//        templateUrl: 'views/components/views/factorings/factorings.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['ttGridFactory', function (ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_factorings_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            let loadGrid = function () {
//                vm.grid.dataTask.loadData = {
//                    method: 3463,
//                    parameters: {}
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            };

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadGrid();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
